var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Coins_Filled",
    "data-name": "icons/Coins/Filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 13.333,
    viewBox: "0 0 13.333 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.311,8.48a.276.276,0,0,0,.38-.1L8.745,4.667A4.667,4.667,0,0,0,4.078,0L.369,2.053a.276.276,0,0,0-.1.38l.121.207a.333.333,0,0,0,.052.067l5.6,5.6a.333.333,0,0,0,.067.052Z",
    transform: "translate(4.588)",
    fill: "#3772ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.667,9.333A4.667,4.667,0,1,1,9.333,4.667,4.667,4.667,0,0,1,4.667,9.333Z",
    transform: "translate(0 4)",
    fill: "#3772ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallImg);
export default __webpack_public_path__ + "static/media/smallImg.d4170d264c45915d8a3e739a2282cad1.svg";
export { ForwardRef as ReactComponent };